import React ,{ PureComponent } from "react";
import { Link } from "react-router-dom";
import * as myConstClass from '../../constant.js';
import { Button } from "reactstrap";
import $ from 'jquery';
class Page405 extends PureComponent {
  constructor(props) {
    super(props);
    this.routeChange = this.routeChange.bind(this);

}
routeChange() {
  this.props.history.push('/');
}
componentDidMount(){
  $('.main').css('background-image', 'none');
        $('.main').css('background-size', 'none');
 // localStorage.clear();
 //alert(localStorage.getItem('login_type'));
}

render() {

  return (
  
    <div className="text-center">
    {/* <h1 className="display-1 font-weight-bold">404</h1>
     <p className="h1">Page not found.</p> */}
    <p className="h2 font-weight-normal mt-3 mb-4">
     Connecting............
    </p> 
     <Link to={'/'+myConstClass.TENANT_PAGE_PATH+"employees/profile"}>
      <Button color="primary" size="lg">
       Return to My Profile and Refresh It
      </Button>
    </Link>
  </div>
  )
}
}


// const Page404 = () => (

//   <div className="text-center">
//     {/* <h1 className="display-1 font-weight-bold">404</h1>
//      <p className="h1">Page not found.</p> */}
//     <p className="h2 font-weight-normal mt-3 mb-4">
//      Connecting............
//     </p> 
//      <Link to={'/'+myConstClass.TENANT_PAGE_PATH+"dashboard"}>
//       <Button color="primary" size="lg">
//        Return to Dashboard
//       </Button>
//     </Link>
//   </div>
// );

export default Page405;


